/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon
} from '../'


export class ActionButton extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    children: PropTypes.string.isRequired,
    iconSymbol: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    titleOnHover: PropTypes.string,
    className: PropTypes.string
  }

  static defaultProps = {
    iconSymbol: 'refresh',
    className: ''
  }

  state = {
    actionInProgress: false
  }

  render() {
    let disabled = this.props.disabled || this.state.actionInProgress
    let { id, iconSymbol, onClick, titleOnHover, className } = this.props

    return (
      <div className={`u-font-size-larger slds-grid ${className}`} style={{ alignItems: 'baseline', lineHeight: 1.1 }} title={titleOnHover}>
        <Button
          id={id}
          disabled={disabled}
          onClick={onClick}
          className='slds-m-top_xx-small slds-m-bottom_x-small slds-m-right_x-small'>
          <SvgIcon
            variant='utility'
            symbol={iconSymbol}
            size='x-small'
            colour={disabled
              ? 'light'
              : 'default'
            }
          />
        </Button>
        {this.state.actionInProgress
          ? 'Regenerating payroll cycle...'
          : this.props.children
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-processing-sidebar/ActionButton.js